import { Anchor } from "@mantine/core";
import { useContact } from "../hooks/useContact.ts";

/**
 * Die Ansprechadresse für Bewerber:innen als Mailto-Link.
 *
 * Solange die Konfiguration noch laedt, steht dort „uns". Der Satz bleibt damit
 * in jedem Fall lesbar („melde dich bei uns") — eine eingebaute Ersatzadresse
 * waere schlimmer als keine, weil sie im Zweifel auf ein falsches Postfach
 * zeigt und niemand merkt es.
 */
export const CandidateContact = () => {
  const contact = useContact();

  if (!contact) {
    return <>uns</>;
  }

  return (
    <Anchor href={`mailto:${contact.candidate}`}>{contact.candidate}</Anchor>
  );
};
